import { DialogActions, DialogContent, useMediaQuery, useTheme } from '@mui/material';
import { ReleaseIdCard } from 'front-office/view-models/release-id-card';
import { Fragment } from 'react';
import { PmiButton } from 'shell/components/shared/button';

import { PmiDialog } from 'shell/components/shared/dialog';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';

export enum ModalType {
  Cid = 0,
  Cartellino = 1,
}

export enum ButtonType {
  PrintTagQuestura = 1,
  PrintTagComune = 2,
}

interface ModalPrintCidProps {
  openModal: boolean;
  onPrintTagQuestura: (values: ReleaseIdCard, type: boolean) => void;
  onPrintTagComune: (values: ReleaseIdCard, type: boolean) => void;
  onInternalPrint: (values: ReleaseIdCard) => void;
  onExternalPrint: (values: ReleaseIdCard) => void;
  onPrintEnvelope: (values: ReleaseIdCard) => void;
  values: ReleaseIdCard;
  onAbort: () => void;
  internalPrintVisibility: boolean;
  externalPrintVisibility: boolean;
  modalType: ModalType;
  setPressedButton: (el: ButtonType) => void;
}

const ModalPrintCid = ({
  openModal,
  onPrintTagQuestura,
  onPrintTagComune,
  values: valuesFormik,
  onAbort,
  internalPrintVisibility,
  onInternalPrint,
  onExternalPrint,
  onPrintEnvelope,
  externalPrintVisibility,
  modalType,
  setPressedButton,
}: ModalPrintCidProps): React.ReactElement => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <Fragment>
      <PmiDialog
        open={openModal}
        aria-labelledby="print-modal"
        aria-describedby="print-modal"
        fullWidth
        fullScreen={fullScreen}
      >
        <PmiDialogTitle id="print-modal-title" backgroundColor="primary" color="white">
          Stampe
        </PmiDialogTitle>
        <DialogContent style={{ padding: '30px 24px', display: 'flex', gap: '20px' }}>
          {modalType === ModalType.Cartellino ? (
            <>
              <PmiButton
                variant="outlined"
                color="cdmBrandThird"
                type="button"
                id={ButtonType.PrintTagQuestura?.toString()}
                onClick={() => {
                  onPrintTagQuestura(valuesFormik, false);
                  setPressedButton(ButtonType.PrintTagQuestura);
                }}
              >
                STAMPA CARTELLINO QUESTURA
              </PmiButton>
              <PmiButton
                variant="outlined"
                color="cdmBrandThird"
                type="button"
                id={ButtonType.PrintTagComune?.toString()}
                onClick={() => {
                  onPrintTagComune(valuesFormik, true);
                  setPressedButton(ButtonType.PrintTagComune);
                }}
              >
                STAMPA CARTELLINO COMUNE
              </PmiButton>
            </>
          ) : undefined}
          {modalType === ModalType.Cid ? (
            <>
              <PmiButton
                disabled={internalPrintVisibility}
                variant="outlined"
                color="cdmBrandThird"
                type="button"
                onClick={() => onInternalPrint(valuesFormik)}
              >
                STAMPA INTERNO
              </PmiButton>
              <PmiButton
                disabled={externalPrintVisibility}
                variant="outlined"
                color="cdmBrandThird"
                type="button"
                onClick={() => onExternalPrint(valuesFormik)}
              >
                STAMPA ESTERNO
              </PmiButton>
              <PmiButton
                variant="outlined"
                color="cdmBrandThird"
                type="button"
                onClick={() => onPrintEnvelope(valuesFormik)}
              >
                STAMPA BUSTA
              </PmiButton>{' '}
            </>
          ) : undefined}
        </DialogContent>
        <DialogActions style={{ padding: '30px 24px' }}>
          <PmiButton variant="outlined" color="cdmBrandThird" type="button" onClick={onAbort}>
            Chiudi
          </PmiButton>
        </DialogActions>
      </PmiDialog>
    </Fragment>
  );
};

ModalPrintCid.displayName = 'Modal print cid component';

export default ModalPrintCid;
